<app-smartsupp [username]="smartsupp.username" [name]="localUser.name"></app-smartsupp>
<div id="mainWrapper"
     [ngClass]="{'teacher-view': localUser?.accessType === AccessType.TEACHER || localUser?.accessType === AccessType.SUPPORT,
               'student-view': localUser?.accessType === AccessType.STUDENT,
               'observer-view': localUser?.accessType === AccessType.OBSERVER,
               'full-screen-modal': localUser.accessType === AccessType.STUDENT && !classroom.isInFullScreenMode && !classroom.isIpadMode,
               'ipad-mode': classroom.isIpadMode}">
  <div class="toolbar-wrapp d-flex align-items-center">
    <div class="logo">
      <img src="assets/img/white-logo.png" alt="RSM Logo">
    </div>
    <div class="class-info d-flex align-items-center text-nowrap">
      <span class="stud-welcome"><b *ngIf="!!localUser"><span
        class="font-size-12">Welcome</span> {{localUser | fullName}}</b></span>
      <span class="d-flex align-items-center">
                <b>{{classroom.currentClass?.additionalInfo?.title}}</b>
                <button class="btn toolbar-btn light-blue-btn ml-3"
                        title="Do Not Disturb on/off"
                        *ngIf="localUser && (localUser.accessType === AccessType.SUPPORT || localUser.accessType === AccessType.TEACHER)"
                        [ngClass]="{'red-btn': classroom.isDnDEnabled}"
                        (click)="toggleDoNotDisturbMode()">
                    <i class="fas fa-lock" [ngClass]="{'fa-lock-open': !classroom.isDnDEnabled}"></i>
                </button>
            </span>
      <span class="topic-name ml-3"
            *ngIf="classroom.currentClass"
            title="{{classroom.currentClass.additionalInfo.lesson}}{{classroom.currentClass.additionalInfo.topic && classroom.currentClass.additionalInfo.topic.length > 0 ? ': ' + classroom.currentClass.additionalInfo.topic : ''}}">
        {{currentDate | date:'MM/dd/yy'}}
        - {{classroom.currentClass.additionalInfo.lesson}}{{classroom.currentClass.additionalInfo.topic && classroom.currentClass.additionalInfo.topic.length > 0 ? ': ' + classroom.currentClass.additionalInfo.topic : ''}} </span>
    </div>

    <div *ngIf="isTimerPopupShown" id="break-timer-toolbar" style="display: block;">
      <div id="break-clock-setup" style="z-index: 1; display: block;">
        <select #selectElement [(ngModel)]="timer.selectedDuration" id="timer-minutes">
          <option *ngFor="let min of timer.durations" value="{{min}}">{{min}} min</option>
        </select>
        <input type="button" (click)="closeTimerPopup()" value="Cancel" class="time-break-cancel-btn"
               title="Cancel timer">
        <input type="button" (click)="startTimer()" value="Start" class="time-break-start-btn"
               title="Start timer"></div>
    </div>


    <div class="d-flex align-items-center ml-auto bg-blue">
      <div class="d-flex mr-2">
        <div id="break-timer"
             [ngStyle]="{'display': classroom.isTimerEnabled ? 'flex' : 'none'}">
          <!--    <div id="clock-div">
                <span id="minutes-time-line">{{min}} : </span>
                <span id="seconds-time-line">{{sec}}</span>
               </div>-->
          <div id="clock-div">
            <span id="minutes-time-line">{{timer.seconds | secondsToTimerValue}}</span>
          </div>
          <div id="timer-icon"
               *ngIf="localUser?.accessType === AccessType.STUDENT || localUser?.accessType === AccessType.OBSERVER"
               class="ng-scope" style="">
            <i class="fas fa-alarm-clock"></i>
          </div>
        </div>

        <div id="systemClock" class="ml-3 mr-3" *ngIf="localUser?.accessType === AccessType.STUDENT">
          {{localTime}}
        </div>

        <button id="timer-button"
                class="btn toolbar-btn light-blue-btn mr-2 ng-scope"
                [ngClass]="{'green-btn':classroom.isTimerEnabled}"
                title="Set Timer"
                *ngIf="localUser?.accessType === AccessType.SUPPORT || localUser?.accessType === AccessType.TEACHER"
                (click)="startBreakTime()">
          <i class="fas fa-alarm-clock"></i>
        </button>
        <button class="btn toolbar-btn class-sound mr-2" (click)="toggleMuteClassroom()"
                title="Quiet Time! [Alt-M]"
                *ngIf="localUser?.accessType === AccessType.SUPPORT || localUser?.accessType === AccessType.TEACHER"
                [ngClass]="{'red-btn off': classroom.isClassroomMuted }"
        ></button>
        <button class="btn toolbar-btn mr-2" (click)="refreshPage()"
                [disabled]="!classroom.isConnectedToSocket || !classroom.isConnectedToWRTCRoom" title="Refresh">
          <i class="fas fa-sync-alt"></i></button>
        <button class="btn toolbar-btn video-mic-btn mr-2" title="Video and audio settings"
                (click)="openAudioVideoDeviceConfigurationDialog('event')"
                *ngIf="localUser?.accessType === AccessType.STUDENT"
                [ngClass]="{'disabled': !classroom.isLocalTracksFetched}"></button>

        <button class="tech-support mr-2" id="techSupport" title="Speak with a live assistant"
                (click)="toggleSmartsuppChat()"><i class="fas fa-comment-dots mr-2"></i>Tech Support
          <span class="support-unread-message"
                *ngIf="smartsupp.unAnsweredMessagesCount > 0">{{smartsupp.unAnsweredMessagesCount}}</span>
        </button>
      </div>

      <div class="mr-3 dropdown" dropdown
           *ngIf="localUser?.accessType === AccessType.SUPPORT || localUser?.accessType === AccessType.TEACHER">
        <button id="button-alignment" type="button" class="btn dropdown-toggle red-btn exit-btn" dropdownToggle
                aria-controls="dropdown-alignment">
          <i class="fa fa-sign-out mr-2"></i>
          Exit lesson
        </button>

        <ul id="dropdown-alignment" *dropdownMenu class="dropdown-menu cs-dropdown-menu dropdown-menu-right"
            role="menu" aria-labelledby="button-alignment">
          <a class="dropdown-item" (click)="logout()">Exit lesson</a>
          <a class="dropdown-item" (click)="openEndLessonDialog()">End Lesson for Everyone</a>
        </ul>
      </div>

      <button type="button" class="btn red-btn exit-btn mr-3"
              title="Leave the classroom"
              *ngIf="localUser?.accessType !== AccessType.SUPPORT && localUser?.accessType !== AccessType.TEACHER"
              (click)="logout()">
        <i class="fa fa-sign-out mr-2"></i>Exit
      </button>
    </div>
  </div>

  <div id="layoutTable" class="d-flex justify-content-between"
       [ngClass]="{'assignment-loaded': localUser?.accessType  === AccessType.STUDENT && assignment.isLoaded}">
    <div id="home" class="center-content d-flex justify-content-center"
         [ngStyle]="{'display': classroom.isConnectedToSocket ? 'block':'none'}">
      <div id="boards-wrap" class="d-flex flex-column flex-wrap">
        <div class="top-part d-flex">
          <div class="bb-tabs">
            <div class="tabs-area">
              <div class="st-bb-btns d-flex align-items-center" style="z-index: 5000"
                   *ngIf="localUser.accessType === AccessType.STUDENT && assignment.isLoaded && !classroom.showPrivateWhiteboard &&
                                    (assignment.allowedSwitchingUsers?.size === 0 || assignment.allowedSwitchingUsers?.has(localUser.id))">
                <button id="wb-btn" title="Private Whiteboard" class="btn wb-btn wb-btn-disabled"
                        [disabled]="!assignment.isFrameLoaded && localUser.currentSelectedTab === ViewPortTab.ASSIGNMENT"
                        [ngClass]="{'active': localUser.currentSelectedTab === ViewPortTab.WHITEBOARD}"
                        (click)="switchViewPortTab(ViewPortTab.WHITEBOARD)">
                </button>

                <button id="assignment-btn" title="Assignment" class="btn assignment-btn"
                        [ngClass]="{'active': localUser.currentSelectedTab === ViewPortTab.ASSIGNMENT}"
                        (click)="switchViewPortTab(ViewPortTab.ASSIGNMENT)">
                </button>
              </div>
              <div class="tab-content">
                <div class="tab-pane fade bb-tab" [ngClass]="{'show active': activatedViewportTab===ViewportTab.BLACKBOARD}">
                      <div app-blackboard id="blackboard"></div>
                </div>
                <div id="users-list-wrapper" class="tab-pane fade chat-tab" [ngClass]="{'show active':activatedViewportTab ===ViewportTab.CHAT}"
                     *ngIf="localUser?.accessType !== AccessType.STUDENT">
                  <app-users-list></app-users-list>
                </div>
              </div>
            </div>
          </div>
          <div class="teacher-with-conts">
            <div class="teacher-video" [hidden]="!classroom.isConnectedToWRTCRoom || !localUser"
                 *ngIf="classroom.isVideoSectionOpen">
              <app-teachers-video-section [remoteTeachers]="usersListService.remoteUsersWrapper.teachers">
              </app-teachers-video-section>
            </div>
            <div class="organize-btns"
                 *ngIf="localUser.accessType === AccessType.SUPPORT || localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.OBSERVER">
              <div class="conts d-flex justify-content-center" *ngIf="localUser.accessType !== AccessType.OBSERVER">
                <button class="fas fa-chess-knight" title="Game mode on/off"
                        [ngClass]="{'active': gameMode.isStarted}"
                        (click)="toggleGameMode()"></button>
                <button class="firework" title="Fireworks"
                        (click)="toggleFireworks()"></button>
                <button class="applause" title="Applause"
                        [ngClass]="{'active': coreService.applauseAudio.class.isPlaying}"
                        (click)="playApplauseSound()"></button>
                <button class="fa fa-compress-alt"
                        title="Collapse mode on/off"
                        *ngIf="usersListService.remoteUsersWrapper.students.length > 15 || classroom.isStudentsSectionCollapsed"
                        [ngClass]="{'fa-expand-alt': classroom.isStudentsSectionCollapsed}"
                        (click)="toggleRoomCollapseMode()"></button>
              </div>
              <ul class="nav flex-column nav-pills">
                <li  class="nav-item">
                  <a href="javascript:void(0)" class="nav-link"
                     [ngClass]="{'active': activatedViewportTab===ViewportTab.BLACKBOARD}" (click)="activateViewportTab()">Blackboard</a>
                </li>
                <li class="nav-item">
                  <a href="javascript:void(0)" class="nav-link" [ngClass]="{'active': activatedViewportTab===ViewportTab.CHAT}" (click)="activateViewportTab()">
                    <span class="chat-count"
                      *ngIf="(usersListService.listUsers | unansweredMessages: localUser: [AccessType.STUDENT]: false) > 0"
                      title="{{ usersListService.listUsers | unansweredMessages: localUser: [AccessType.STUDENT]: false }} unread message(s)"
                    >
                      {{ usersListService.listUsers | unansweredMessages: localUser: [AccessType.STUDENT]: false }}
                    </span>
                    Chats
                    <span class="chat-tab-icons d-flex align-items-center">
                      <i class="fa-solid fa-headset" title="Support"
                         *ngIf="classroom.atLeastOneSupportInClassroom || localUser.accessType=== AccessType.SUPPORT "></i>
                      <i class="fa-solid fa-binoculars ml-2" title="Observer"
                         *ngIf="classroom.atLeastOneObserverInClassroom || localUser.accessType=== AccessType.OBSERVER"></i>
                      <span class="chat-count"
                            style="background: #0080ff; position: unset; margin-top: 0; margin-left: 5px"
                            *ngIf="(usersListService.listUsers | unansweredMessages: localUser: [AccessType.TEACHER, AccessType.SUPPORT, AccessType.OBSERVER]) > 0"
                            title="{{ usersListService.listUsers | unansweredMessages: localUser: [AccessType.TEACHER, AccessType.SUPPORT, AccessType.OBSERVER] }} unread message(s)">
                        {{ usersListService.listUsers | unansweredMessages: localUser: [AccessType.TEACHER, AccessType.SUPPORT, AccessType.OBSERVER] }}
                      </span>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="d-flex position-relative overflow-hidden">
          <div class="wb-assignment-container"
               [hidden]="!(classroom.privateTalkInfo.isPrivateWhiteboardOn && classroom.showPrivateWhiteboard)">
            <div class="wb-assignment-buttons-box">
              <app-student-toolbar
                [enableGlobalListeners]="classroom.showPrivateWhiteboard"
                [whiteboard]="privateWhiteboard"
                [whiteboardService]="privateWhiteboardService"
                *ngIf="localUser.accessType === AccessType.STUDENT"
                [hidden]="classroom.selectedBoardTab === ViewPortTab.ASSIGNMENT">
              </app-student-toolbar>
              <app-observer-toolbar
                [whiteboardService]="privateWhiteboardService"
                *ngIf="localUser.accessType === AccessType.OBSERVER">
              </app-observer-toolbar>
              <app-staff-toolbar
                *ngIf="localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.SUPPORT"
                [enableGlobalListeners]="classroom.showPrivateWhiteboard"
                [whiteboard]="privateWhiteboard"
                [whiteboardService]="privateWhiteboardService">
              </app-staff-toolbar>
            </div>

            <div id="privateWhiteboardWrapper"
                 [style]="{
                border: privateWhiteboard.sharedUsers?.size === 0 ? '1px solid #0000FF' : '1px solid #C3C3C3',
                overflow: localUser.accessType === AccessType.STUDENT || localUser.accessType === AccessType.OBSERVER ? 'hidden' : ''
              }">
              <app-whiteboard-menus
                [whiteboard]="privateWhiteboard"
                [whiteboardService]="privateWhiteboardService"
                [whiteboardWrapperId]="'privateWhiteboardWrapper'">
              </app-whiteboard-menus>
              <app-private-whiteboard></app-private-whiteboard>
            </div>
          </div>

          <div class="wb-assignment-container"
               [hidden]="classroom.privateTalkInfo.isPrivateWhiteboardOn && classroom.showPrivateWhiteboard">

            <app-whiteboard-loader *ngIf="
              coreService.savingWhiteboardSnapshot && (
                this.localUser.accessType === AccessType.TEACHER ||
                this.localUser.accessType === AccessType.SUPPORT || (
                  this.localUser.accessType === AccessType.STUDENT && (whiteboard | isSharedWith:this.localUser.id)
                )
              )
            ">

            </app-whiteboard-loader>

            <div class="wb-assignment-buttons-box">
              <app-student-toolbar
                [enableGlobalListeners]="!classroom.showPrivateWhiteboard"
                [whiteboard]="whiteboard"
                [whiteboardService]="whiteboardService"
                *ngIf="localUser.accessType === AccessType.STUDENT"
                [hidden]="classroom.selectedBoardTab === ViewPortTab.ASSIGNMENT">
              </app-student-toolbar>
              <app-observer-toolbar
                [whiteboardService]="whiteboardService"
                *ngIf="localUser.accessType === AccessType.OBSERVER">
              </app-observer-toolbar>
              <app-staff-toolbar
                *ngIf="localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.SUPPORT"
                [enableGlobalListeners]="!classroom.showPrivateWhiteboard"
                [isInRestrictedMode]="localUser.accessType === AccessType.SUPPORT"
                [whiteboard]="whiteboard"
                [whiteboardService]="whiteboardService">
              </app-staff-toolbar>
            </div>

            <div id="whiteboardWrapper" [hidden]="classroom.selectedBoardTab !== ViewPortTab.WHITEBOARD"
                 [style]="{
              border: whiteboard.sharedUsers?.size === 0 ? '1px solid #0000FF' : '1px solid #C3C3C3',
              overflow: localUser.accessType === AccessType.STUDENT || localUser.accessType === AccessType.OBSERVER ? 'hidden' : ''
            }">
              <app-whiteboard-menus
                [whiteboard]="whiteboard"
                [whiteboardService]="whiteboardService"
                [whiteboardWrapperId]="'whiteboardWrapper'">
              </app-whiteboard-menus>

              <app-whiteboard></app-whiteboard>
            </div>

            <app-assignment></app-assignment>
            <app-report></app-report>
          </div>

          <app-chat-box class="chat-box" [height]="0"></app-chat-box>
        </div>
      </div>
    </div>
    <div class="content-right d-flex flex-column" [ngClass]="{'expand-mode': classroom.isStudentsSectionCollapsed}">
      <app-game-mode *ngIf="localUser.accessType === AccessType.STUDENT && gameMode.isStarted"></app-game-mode>

      <div class="scroll-wrapper"
           [hidden]="!classroom.isConnectedToWRTCRoom || !localUser"
           *ngIf="classroom.isVideoSectionOpen">
        <app-students-section></app-students-section>
      </div>
    </div>

    <div cdkDragBoundary="body" [cdkDragFreeDragPosition]="privateTalkPopUpPosition" cdkDrag class="alert-privet-talk">
      <div class="alert alert-warning"
           *ngIf="(localUser?.accessType === AccessType.TEACHER || localUser?.accessType === AccessType.SUPPORT) && classroom.privateTalkInfo.isStarted">
        <div class="d-flex align-items-center w-100">
          <div *ngIf="localUser?.accessType === AccessType.TEACHER">You are currently engaged in Private Talk Mode with {{Object.keys(classroom.privateTalkInfo.participants).length}} student(s).</div>
          <div *ngIf="localUser?.accessType === AccessType.SUPPORT">The Teacher is talking privately with student.</div>
          <button type="button" class="btn ml-4" (click)="sendEndPrivateTalk()">End Private Talk</button>
        </div>
        <div class="private-wb-switchers d-flex align-items-center w-100 mt-2 pt-2">
          <div class="d-flex align-items-center">
            <div class="mr-2">Private WB</div>
            <div class="wb-switcher d-flex">
              <button type="button" class="btn whiteboard-btn switcher-wb-a-btn mr-0"
                      title="Whiteboard"
                      (click)="startPrivateWhiteboard()"
                      [class]="{'active': classroom.privateTalkInfo.isPrivateWhiteboardOn}">On
              </button>
              <button type="button" class="btn whiteboard-btn switcher-wb-a-btn ml-0"
                      title="Assignment"
                      (click)="endPrivateWhiteboard()"
                      [class]="{'active': !classroom.privateTalkInfo.isPrivateWhiteboardOn}">Off
              </button>
            </div>
          </div>
          <div class="d-flex align-items-center ml-4" *ngIf="classroom.privateTalkInfo.isPrivateWhiteboardOn">
            <div class="mr-2">Switch WB</div>
            <div class="wb-switcher d-flex">
              <button type="button" class="btn whiteboard-btn switcher-wb-a-btn ml-0"
                      title="Private Whiteboard"
                      (click)="showPrivateWhiteboard()"
                      [class]="{'active': classroom.showPrivateWhiteboard}">Private
              </button>
              <button type="button" class="btn whiteboard-btn switcher-wb-a-btn mr-0"
                      title="Class Whiteboard"
                      (click)="hidePrivateWhiteboard()"
                      [class]="{'active': !classroom.showPrivateWhiteboard}">Class
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="alert alert-info d-flex align-items-center"
           *ngIf="assignment.isLoaded && localUser?.accessType !== AccessType.STUDENT && classroom.showAllStudentsAreOnWB">
        <span class="fa fa-info-circle mr-2"></span>
        <div class="mr-4">All students switched to the Whiteboard. You may Unload the assignment.</div>
        <button type="button" class="close ml-auto">
          <span aria-hidden="true" (click)="hideAllStudentsAreOnWBMessage()">&times;</span>
        </button>
      </div>
<!--      <div class="alert alert-primary d-flex align-items-center"-->
<!--        *ngIf="currentParticipantInfo?.role === Role.STUDENT && showSuggestionToSwitchToWB">-->
<!--        <span class="fa fa-info-circle mr-3"></span>-->
<!--        <div>The teacher is asking you to switch to the Whiteboard.</div>-->
<!--      </div>-->
    </div>

    <app-curriculum></app-curriculum>

    <app-students-fullscreen-mask *ngIf="localUser.accessType === AccessType.STUDENT">
    </app-students-fullscreen-mask>

    <span id="status" class="d-none">{{statusNotification}}</span>
  </div>
</div>
